import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const CargoCompanyList = () =>
    request({
        url: ApiURL.Query.CompanyList,
        method: RequestType.GET,
    });
const CityList = (params: any) => {
    let url =
        ApiURL.Query.GetCargoCityList +
        '?CountryId=' +
        params.countryId +
        '&AddressEntityTypeId=' +
        params.addressEntityTypeId;
    if (params?.parentAddressEntityId != null) {
        url += '&ParentAddressEntityId=' + params.parentAddressEntityId;
    }
    return request({
        url,
        method: RequestType.GET,
    });
};
const CountyList = (data: any) =>
    request({
        url: ApiURL.Query.GetCountyList,
        method: RequestType.POST,
        data: data,
    });
const CargoPriorityList = (params: any) =>
    request({
        url: ApiURL.Query.CargoPriorityList,
        method: RequestType.POST,
        params,
    });
const SubAddressEntities = (data: any) =>
    request({
        url: ApiURL.Query.SubAddressEntities,
        method: RequestType.POST,
        data: data,
    });
const CargoCompanyPriorityCity = (params: any) =>
    request({
        url: ApiURL.Query.CargoCompanyPriorityCity,
        method: RequestType.POST,
        params,
    });
const CountryAddressRulesforCountryId = () =>
    request({
        url: ApiURL.Query.CountryAddressRulesforCountryId,
        method: RequestType.GET,
    });
const MobileCountryAddressRule = (data: { deliveryMethodId: number }) =>
    request({
        url: ApiURL.Query.MobileCountryAddressRule,
        method: RequestType.POST,
        data,
    });
const GetPickPoints = (params: { AddressEntityId: number | string }) =>
    request({
        url: ApiURL.Query.GetPickPoints,
        method: RequestType.GET,
        params,
    });
const GetPostalCodeList = () =>
    request({
        url: ApiURL.Query.GetPostalCodeList,
        method: RequestType.GET,
    });
const GetRegion = (params?: any) =>
    request({
        url: ApiURL.Query.GetRegion,
        method: RequestType.GET,
        params,
    });
const GetStreet = (params?: any) =>
    request({
        url: ApiURL.Query.GetStreet,
        method: RequestType.GET,
        params,
    });
const GetDistrict = (params?: any) =>
    request({
        url: ApiURL.Query.GetDistrict,
        method: RequestType.GET,
        params,
    });
const CargoManagementQuery = {
    CargoCompanyList,
    CityList,
    CountyList,
    CargoPriorityList,
    SubAddressEntities,
    CargoCompanyPriorityCity,
    CountryAddressRulesforCountryId,
    MobileCountryAddressRule,
    GetPickPoints,
    GetPostalCodeList,
    GetRegion,
    GetStreet,
    GetDistrict,
};

export default CargoManagementQuery;
